import { css } from 'lit';

export const styles = css`
  :host(:not(:last-child)) > div:not(.barrel-wrapper-closed) {
    padding-bottom: calc(40em / var(--default-rem-px-count));
  }

  .barrel-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: calc(60em / var(--default-rem-px-count));
    border-top: 2px solid #222222;
  }

  .barrel-header span {
    display: flex;
    align-items: center;
  }

  .barrel-heavy-text {
    font-weight: 500;
  }

  .barrel-header-icon {
    display: flex;
    justify-content: right;
    min-height: 2em;
    min-width: 2em;
  }

  .barrel-text {
    line-height: 1.45em;
  }

  /* MATERIAL BARREL */
  .input-row-wrapper {
    width: 100%;
    display: inline-grid;
    grid-template-columns:
      [mat-header]
      30%
      [mat-value]
      auto
      [end];
    padding-top: calc(24em / var(--default-rem-px-count));
    padding-bottom: calc(20em / var(--default-rem-px-count));
    gap: 0 1em;
  }

  .input-row-wrapper:not(:last-child) {
    border-bottom: 1px solid #c0c0c0;
  }

  .input-row-wrapper:nth-child(2) {
    padding-top: calc(14em / var(--default-rem-px-count));
  }

  .input-row-wrapper:last-child {
    padding-bottom: 0;
  }

  .input-row-header {
    grid-area: mat-header;
  }

  .input-row-value {
    grid-area: mat-value;
  }

  .row-content-text p:not(:last-child) {
    padding-bottom: calc(8em / var(--default-rem-px-count));
  }

  .gauge-selection {
    width: 100%;
    display: inline-grid;
    grid-template-columns: 1fr repeat(3, minmax(0, 3fr));
    padding-top: calc(24em / var(--default-rem-px-count));
    padding-bottom: calc(20em / var(--default-rem-px-count));
    gap: 0 1em;
  }

  .gauge-selection > input {
    height: 1em;
  }

  .gauge-selection > span {
    padding-bottom: calc(20em / var(--default-rem-px-count));
  }

  .totals-wrapper {
    padding-right: calc(60em / var(--default-rem-px-count));
  }

  .order-totals {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: calc(20em / var(--default-rem-px-count));
  }

  .column-direction {
    display: flex;
    flex-direction: column;
    gap: calc(10em / var(--default-rem-px-count));
    padding-bottom: calc(14em / var(--default-rem-px-count));
  }

  .help-text {
    padding-top: calc(8em / var(--default-rem-px-count));
  }

  .with-input p {
    padding-top: calc(10em / var(--default-rem-px-count));
  }

  /* Override browser defaults */
  input[type='number'] {
    -webkit-appearance: none;
    outline: none;
    box-shadow: none;
    border: none;
    padding: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
    border: 1px solid #cccccc;
    height: calc(32rem / var(--default-rem-px-count));
    width: calc(200rem / var(--default-rem-px-count));
    padding-top: calc(2rem / var(--default-rem-px-count));
    padding-left: calc(12rem / var(--default-rem-px-count));
    display: block;
  }

  @media print {
    .barrel-header {
      border-top: 1px solid #222222;
    }

    .input-row-wrapper:not(:last-child) {
      border-bottom: 0.75px solid #c0c0c0;
    }

    .barrel-heavy-text {
      font-size: 10px;
      letter-spacing: -0.05px;
      line-height: 18px;
    }

    .input-row-wrapper p {
      font-size: 9px;
      letter-spacing: -0.05px;
      line-height: 12px;
    }
  }
`;
